var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("pdf-view"),
      _vm._v(" "),
      _c(
        "h3",
        [
          _c("v-icon", [_vm._v("today")]),
          _vm._v("\n    Resumen de asistencias\n    "),
          _c(
            "v-menu",
            {
              attrs: { "open-on-hover": "", buttom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c("v-icon", _vm._g({}, on), [_vm._v("help_outline")])
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "warning" },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { staticClass: "text-xs-center caption" },
                            [
                              _c("strong", [
                                _c(
                                  "p",
                                  [_c("v-icon", [_vm._v("help_outline")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("p", [_vm._v("Puede generar un reporte")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("con los atrasos y días")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("trabajados de uno o todos")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("los funcionarios en un")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("rango de fechas.")])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "secondary" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.obtenerAsistencias()
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.personas,
                                  "item-text": function(val) {
                                    return (
                                      val.nombres +
                                      " " +
                                      val.ap_paterno +
                                      " " +
                                      val.ap_materno
                                    )
                                  },
                                  "item-value": function(val) {
                                    return val.id
                                  },
                                  rules: _vm.form.todos
                                    ? []
                                    : _vm.$validate(["required"]),
                                  label: "Seleccione un funcionario",
                                  loading: _vm.cargaFuncionarios,
                                  disabled: _vm.form.todos
                                },
                                on: {
                                  input: function($event) {
                                    _vm.bandera_genera = false
                                  }
                                },
                                model: {
                                  value: _vm.form.id_persona,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_persona", $$v)
                                  },
                                  expression: "form.id_persona"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: { label: "Todos los funcionarios" },
                                model: {
                                  value: _vm.form.todos,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "todos", $$v)
                                  },
                                  expression: "form.todos"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha desde"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.bandera_genera = false
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde", $$v)
                                  },
                                  expression: "form.fecha_desde"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label: "Fecha hasta"
                                },
                                on: {
                                  input: function($event) {
                                    _vm.bandera_genera = false
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta", $$v)
                                  },
                                  expression: "form.fecha_hasta"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "blue",
                                    loading: _vm.loading,
                                    dark: "",
                                    block: "",
                                    type: "submit"
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("schedule")]),
                                  _vm._v(
                                    "\n                Generar\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.lista.length > 0
            ? _c(
                "v-card-text",
                { staticClass: "primary" },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "white--text", attrs: { wrap: "" } },
                        [
                          _c("v-flex", { attrs: { md6: "" } }, [
                            _c("p", [
                              _c("strong", [_vm._v("Rango de fechas:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.fechas.desde) +
                                  " al\n              " +
                                  _vm._s(_vm.fechas.hasta) +
                                  "\n            "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.lista.length == 0 && _vm.bandera_genera
            ? _c(
                "v-card-text",
                { staticClass: "primary" },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { staticClass: "white--text", attrs: { wrap: "" } },
                        [
                          _c("v-flex"),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md24: "" } }, [
                            _c("h1", [_vm._v("No existen datos")])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.lista.length > 0
            ? _c(
                "v-card-text",
                { staticClass: "primary" },
                [
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.lista,
                      "hide-actions": "",
                      "item-key": "index",
                      search: _vm.search
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.nombres))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.unidad))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.dia))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.fecha))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-xs-center" }, [
                                _vm._v(_vm._s(props.item.hora))
                              ])
                            ]
                          }
                        },
                        {
                          key: "no-results",
                          fn: function() {
                            return [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: true,
                                    color: "error",
                                    icon: "warning"
                                  }
                                },
                                [
                                  _vm._v(
                                    '\n            No se encontró resultados para la busqueda "' +
                                      _vm._s(_vm.search) +
                                      '".\n          '
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1783852407
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c31c5d3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31c5d3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/AsistenciaResumen.vue
// module id = null
// module chunks = 